export const gradeGuideRoutePaths = {
  gradeGuide: {
    path: 'grade-guide',
    fullPath: '/grade-guide',
  },
};
